import { GroupsService } from '@/service/GroupsService'
import Model from './Model'

export interface IGroupMember {
  _id?: string
  fullName: string
  contactId: string
  slug: string
  groupId: string
  joiningDate: string
  role: GroupMemberRole
  status: GroupMemberStatus
  avatar?: string
}

export enum GroupMemberRole {
  MEMBER = 'MEMBER',
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
}

export enum GroupMemberStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export default class GroupMember extends Model {
  constructor(payload: IGroupMember) {
    super(payload, GroupsService)
  }

  set id(_id: string) {
    this._data._id = _id
  }

  get id(): string {
    return this._data._id
  }

  get fullName(): string {
    return this._data.fullName
  }

  set fullName(fullName: string) {
    this._data.fullName = fullName
  }

  get contactId(): string {
    return this._data.contactId
  }

  set contactId(contactId: string) {
    this._data.contactId = contactId
  }

  get groupId(): string {
    return this._data.groupId
  }

  set groupId(groupId: string) {
    this._data.groupId = groupId
  }

  get slug(): string {
    return this._data.slug
  }

  set slug(slug: string) {
    this._data.slug = slug
  }

  get joiningDate(): string {
    return this._data.joiningDate
  }

  set joiningDate(joiningDate: string) {
    this._data.joiningDate = joiningDate
  }

  get role(): GroupMemberRole {
    return this._data.role
  }

  set role(role: GroupMemberRole) {
    this._data.role = role
  }
  get status(): GroupMemberStatus {
    return this._data.status
  }

  set status(status: GroupMemberStatus) {
    this._data.status = status
  }

  get avatar(): string {
    return this._data.avatar
  }

  set avatar(avatar: string) {
    this._data.avatar = avatar
  }
}
